<template>
    <v-app>
        <header-frame/>

        <v-main>

            <v-container
                fluid
                class="pa-4 pb-0"
            >
                <v-layout>
                    <v-flex>
                        <v-card
                            class="mx-auto"
                            max-width="800"
                            flat
                        >
                            <v-card-title class="display-1 text-break pb-0 px-0 ml-2">
                                <span class="gradient">Vreet</span>
                            </v-card-title>
                            <v-card-title class="mt-0 display-3 text-break pt-0 px-0">
                                Dinner Time!
                            </v-card-title>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>

            <v-container
                fluid
                class="pa-4 pt-0"
            >
                <v-layout>
                    <v-sheet
                        class="mx-auto"
                        width="800"
                    >
                        <v-layout class="flex-wrap">
                            <v-flex class="pa-2 flex-wrapped">
                                <v-img src="storage/eat.png" contain position="center bottom" class="image"></v-img>
                            </v-flex>
                            <v-flex class="pa-2 flex-wrapped">
                                <v-card
                                    class="mx-auto"
                                    flat
                                >
                                    <v-card-title class="justify-center text-center text-break pa-0 pb-4">
                                        Getting started
                                    </v-card-title>
                                    <v-card-subtitle class="text-center text-break px-0">
                                        Follow these steps!
                                    </v-card-subtitle>
                                    <v-stepper vertical class="py-0">
                                        <v-stepper-step step="1" class="v-stepper__step--active stepper">
                                            Register your account above.
                                        </v-stepper-step>
                                        <v-stepper-content step="1"></v-stepper-content>
                                        <v-stepper-step step="2" class="v-stepper__step--active stepper">
                                            Add a house or join one.
                                        </v-stepper-step>
                                        <v-stepper-content step="2"></v-stepper-content>
                                        <v-stepper-step step="3" class="v-stepper__step--active stepper">
                                            Eat eat eat!
                                        </v-stepper-step>
                                    </v-stepper>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-sheet>
                </v-layout>
            </v-container>

        </v-main>

        <footer-frame/>
    </v-app>
</template>

<script>
import HeaderFrame from '@/js/components/HeaderFrame'
import FooterFrame from '@/js/components/FooterFrame'

export default {
  name: 'Home',
  components: {
    HeaderFrame,
    FooterFrame
  },
  created () {
    // if (this.$auth.check()) {
    //   this.$router.replace('/dashboard/account')
    // }
  },
  data: () => ({
  }),
  methods: {
  }
}
</script>

<style>
    html {
        overflow-y : auto !important;
        overflow-x : hidden !important;
    }

    body {
        overflow-y : auto !important;
        overflow-x : hidden !important;
    }

    .link {
        color           : inherit !important;
        text-decoration : inherit !important;
        transition      : .3s cubic-bezier(.25, .8, .5, 1) !important;
    }

    .link:hover {
        color : #ff8765 !important;
    }

    .link-no-href {
        text-decoration: underline !important;
    }

    .text--black {
        color: rgba(0,0,0,.87) !important;
    }

    .image {
        height: 100% !important;
    }

    .image .v-responsive__content {
        width : auto !important;
    }

    .table-container {
        max-width    : 1500px !important;
        margin-left  : auto !important;
        margin-right : auto !important;
    }

    .form-container {
        max-width    : 500px !important;
        margin-left  : auto !important;
        margin-right : auto !important;
    }

    .flex-wrapped {
        flex-basis   : 50% !important;
        margin-left  : auto !important;
        margin-right : auto !important;
    }

    .flex-half {
        width : 50% !important;
    }

    .v-toolbar__title {
        flex-shrink : 0 !important;
    }

    .spacer {
        min-width : 8px !important;
    }

    .select {
        max-width   : 140px !important;
    }
    .search {
        /*padding-top : 10px !important;*/
        max-width : 300px !important;
    }

    .v-dialog .v-card {
        height : 100% !important;
    }

    .mobileToolbar {
        height : auto !important;
    }

    .mobileToolbar .v-toolbar__content {
        height         : auto !important;
        flex-wrap      : wrap !important;
        padding-bottom : 8px !important;
    }

    .mobileToolbar .v-toolbar__content .v-toolbar__title {
        padding-top : 9px !important;
    }

    .mobileToolbar .v-toolbar__content .v-input {
        max-width: none !important;
        margin-top  : 4px !important;
        padding-top : 12px !important;
    }

    .mobileToolbar .v-toolbar__content .v-btn {
        margin-top  : 8px !important;
    }

    .expansion .v-expansion-panel:before {
        box-shadow: none !important;
    }

    .expansion .v-expansion-panel-header {
        min-height : 48px !important;
    }

    .expansion .v-expansion-panel .v-expansion-panel-content .v-expansion-panel-content__wrap {
        padding : 0 16px !important;
    }

    table .v-data-table-header-mobile tr th {
        height: 0 !important;
    }

    tbody .v-data-table__mobile-table-row:nth-child(even) td {
        background-color: #eee !important;
    }

    .plain-btn:before, .plain-btn-no-click:before {
        display: none !important;
    }
    .plain-btn-no-click {
        cursor: default !important;
    }

    .costs-table .v-data-table__wrapper table thead th:first-child {
        min-width: 132px !important;
    }

    th {
        white-space: nowrap;
    }
    table .v-data-table__mobile-row {
        white-space: normal !important;
    }
</style>

<style scoped>
    .gradient {
        background: linear-gradient(90deg, #ff5e62 10%, #ff9966 90%);
        -webkit-background-clip: text !important;
        -webkit-text-fill-color: transparent !important;
    }

    .layout-title {
        text-align : center !important;
    }

    .flex-center {
        display         : flex !important;
        justify-content : center !important;
    }

    .stepper /deep/ .v-stepper__step__step {
        background-color : #ff8765 !important;
    }

    .stepper /deep/ .v-stepper__label {
        text-shadow : none !important;
        color: rgba(0,0,0,.87) !important;
    }
</style>
